import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card, Select, message } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import apiClient from '../services/apiClient';

// Card pra gerenciar quem recebe o relatorio executivo recorrente por
// e-mail (envio mensal, ver backend/src/jobs/monthlyReportEmail.ts). Fica
// vazio/desligado ate o admin/comercial do tenant cadastrar pelo menos um
// destinatario - nao ha destinatario padrao.
const ReportEmailRecipientsCard: React.FC = () => {
  const [recipients, setRecipients] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiClient.get('/report-settings/recipients');
      setRecipients(response.data?.recipients || []);
    } catch (error) {
      console.error('Erro ao carregar destinatários do relatório recorrente:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await apiClient.put('/report-settings/recipients', { recipients });
      message.success(
        recipients.length > 0
          ? 'Destinatários salvos. O relatório executivo será reenviado mensalmente para essa lista.'
          : 'Lista limpa - o envio mensal automático está desligado.'
      );
    } catch (error: any) {
      message.error(error.response?.data?.error || 'Erro ao salvar destinatários.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card
      title={<span><MailOutlined /> Relatório executivo recorrente</span>}
      style={{ marginBottom: 16 }}
      loading={loading}
    >
      <p style={{ marginTop: 0, color: '#8c8c8c' }}>
        Quem estiver nessa lista recebe por e-mail, uma vez por mês, o relatório executivo mais recente de cada conta conectada.
      </p>
      <Select
        mode="tags"
        style={{ width: '100%', maxWidth: 560 }}
        placeholder="Adicione um ou mais e-mails e pressione Enter"
        value={recipients}
        onChange={setRecipients}
        tokenSeparators={[',', ' ']}
        options={[]}
      />
      <div style={{ marginTop: 12 }}>
        <Button type="primary" onClick={handleSave} loading={saving}>
          Salvar destinatários
        </Button>
      </div>
    </Card>
  );
};

export default ReportEmailRecipientsCard;
